import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private duration = 3000;

  constructor(private snackBar: MatSnackBar) {}


  /* Success */
  success(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-success'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /* Error */
  error(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-error'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /* Warning */
  warning(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-warning'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /* Info */
  info(message: string, duration?: number) {

    this.snackBar.open(
      message,
      'Close',
      {
        duration: duration || this.duration,
        panelClass: ['snackbar-info'],
        horizontalPosition: 'right',
        verticalPosition: 'top'
      }
    );
  }


  /**
   * Extract the real backend/DB error message from an HttpErrorResponse
   * (or any thrown error), falling back to a generic message when none is found.
   * The backend may return the message under a variety of keys, so we probe the
   * common ones and ignore Angular's generic "Http failure response ..." text.
   */
  extractMessage(err: any, fallback = 'Something went wrong. Please try again.'): string {
    const body = err?.error ?? err;
    let raw: any = null;

    if (typeof body === 'string') {
      raw = body;
    } else if (body && typeof body === 'object') {
      raw = body.Message ?? body.message
         ?? body.ERROR ?? body.Error ?? body.error
         ?? body.MESSAGE ?? body.msg
         ?? body.detail ?? body.Detail ?? body.title
         ?? null;
    }
    if (raw == null) raw = err?.message ?? null;

    const text = typeof raw === 'string' ? raw.trim() : '';
    // Ignore Angular's generic transport error and empty payloads
    if (!text || /^http failure/i.test(text)) return fallback;
    return text;
  }

  /* Error using the real backend/DB message when available */
  apiError(err: any, fallback?: string, duration?: number) {
    this.error(this.extractMessage(err, fallback), duration);
  }

}
